<template>
  <div>
    <search-bar @search="onSearch" name="ve_name" placeholder="输入供应商进行查找" ref="searchBar" />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="(item, index) in items"
        :key="index"
        @click="gotoView(item)"
      >
        <div class="weui-cell__bd">
          <p>{{item.ve_name}}</p>
          <!-- <p class="list-item-muted">{{item.ve_buyername}}</p> -->
        </div>
        <div class="weui-cell__ft">
          <p>{{item.vm_yearmonth}}</p>
          <!-- <p class="list-item-muted" v-format="'#,##0.00'">{{item.vm_end}}</p> -->
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}笔</label>
      <!-- <em class="list-footer__value">
        合计：
        <span v-format="'#,##0.00'">{{getTotal()}}</span>元
      </em> -->
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/ledger/es_month/list",
      params: {
        mode: "DETAIL",
        number: 1,
        size: 99999,
        calculateFields: JSON.stringify([
          {"field":"vm_begin_gs","operation":"sum"},
          {"field":"vm_add_gs","operation":"sum"},
          {"field":"vm_reduce_gs","operation":"sum"},
          {"field":"vm_end_gs","operation":"sum"}
        ]),
        page: 1,
        start: 0,
        limit: 99999
      },
      filters: [
        {
          type: "period",
          name: "vm_yearmonth"
        }
      ]
    };
  },
  mounted() {
    this.doSearch()
  },  
  methods: {
    gotoView(item) {
      this.$router.push({
        name: "MoneyPaytenestidetailReportDetail",
        params: {
          initData: Object.assign({}, item),
        }
      })
    }
  }
};
</script>